module.exports = __webpack_public_path__ + "static/hifi9-dea1157d6cceda3e766511726084ea05.jpg";